import { FormationDetailProps } from "@/types/formation";

export const hydrocurageFormation: FormationDetailProps = {
  id: "12",
  title: "Formation Hydrocurage",
  description: "Cette formation permet d'acquérir les compétences nécessaires pour exercer en tant qu'hydrocureur, chauffeur et opérateur ou chef de bord.",
  duration: "14 heures (2 jours)",
  category: "Assainissement",
  imageSrc: "/images/formations/hydrofiche.webp",
  slug: "hydrocurage",
  reference: "F-HYDRO",
  price: "Sur devis – nous contacter",
  targetAudience: "Toute personne exerçant une activité hydrocureur, chauffeur et opérateur ou chef de bord",
  prerequisites: "Être âgé de 18 ans\nÊtre apte médical",
  objectives: [
    "Connaître les différents camions à ADR",
    "Connaître les différentes pompes HP",
    "Connaître les principes de fonctionnement de l'hydroseuse",
    "Connaître l'intervention des réseaux sensibles",
    "Entretenir le matériel",
    "Doser correctement l'outillage de curage adapté à la pompe HP"
  ],
  program: [
    {
      title: "Premier jour",
      items: [
        "Accueil des stagiaires, relatives à l'utilisation du vélo",
        "Principe",
        "Rappel physique",
        "Les contraintes hydrauliques",
        "Les écoulements hydrauliques",
        "Conception : présentation des fusées hydrauliques",
        "Comment reconnaître un réseau (fonte, grès, pvc, plastique, plomb, etc)",
        "Circuit de vidéo caméra",
        "Circuit hydraulique",
        "Matériel, outillage",
        "Balisage chantier mobile"
      ]
    },
    {
      title: "2ème Jour",
      items: [
        "Débouchage simple de regards (partie technique)",
        "Présentation du débit, perte de charge",
        "Prise des mesures du débit",
        "Traçage, réseau à neuf",
        "Procédure contre le gel",
        "Risque HP",
        "Mode opératoire HP"
      ]
    },
    {
      title: "PARTIE PRATIQUE",
      items: [
        "Mise en situation pratique sur site"
      ]
    }
  ],
  pedagogicalMethods: [
    "Exposés interactifs, démonstrations par le formateur, mise en situation pratique, exercice sur site"
  ],
  evaluationMethods: [
    "En 1er jour de la formation : Questionnaire des besoins et positionnement de l'apprenant",
    "Pendant la formation : Atelier pratique en situation réelle + exercices applicatifs",
    "Fin de formation : QCM pour évaluation des acquis + évaluation de satisfaction à chaud",
    "Après la formation : Évaluation à froid pour vérifier les compétences de l'apprenant"
  ],
  certification: "Cette action de formation sera validée par un certificat de réalisation nominative, après la réalisation du QCM final par l'évaluation des acquis.",
  effectif: "4 stagiaires minimum et 10 stagiaires maximum",
  registrationProcess: [
    "Inscription par téléphone, par mail ou par le site internet",
    "Délai d'accès selon un agenda interne de session de l'entreprise",
    "Inscription 15 jours avant le début de la formation"
  ],
  accessibilityCriteria: "Pour toute personne en situation d'handicap, Nous sommes susceptibles d'accueillir les personnes moins de nous contacter au préalable pour étudier toute situation.",
  formatterInfo: {
    name: "Sebastien Davrainville - SDPSI Formation",
    phone: "06.22.61.04.09",
    email: "sdpsiformation@orange.fr",
    website: "www.sdpsi-formations.fr"
  }
};
